import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getallapasscode_thunk, checkpasscodeexistance_thunk, checkpasscodeusability_thunk, generatepasscode_thunk, deletepasscode_thunk } from "./PasscodeManager.Thunk";

// components
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";

// MUI
import { Grid, Box, Paper, Card, CardContent, Typography, Dialog, Button, Slide, IconButton, AppBar, Toolbar, DialogContentText, DialogActions, DialogContent, DialogTitle, TextField, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function PasscodeManagerPage() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.PasscodeManagerSlice.data.data);
  const loading = useSelector((state) => state.PasscodeManagerSlice.loading);
  // --------------------- Page Load ------------------------
  // Get all managers
  useEffect(() => {
    dispatch(getallapasscode_thunk());
  }, [dispatch]);
  // -------------------------------------------------------

  // ---------------------- Manager type on change ---------
  const [managertype, setManagertype] = useState("all");
  const [userdata, setUserdata] = useState(data);
  const managertype_select_onchange = async (e) => {
    setManagertype(e.target.value);
  };

  useEffect(() => {
    if (managertype === "all") setUserdata(data);
    else if (managertype === "manager") setUserdata(data && data.filter((item) => item.managertype === "manager"));
    else if (managertype === "crc") setUserdata(data && data.filter((item) => item.managertype === "crc"));
  }, [managertype, data]);
  // -------------------------------------------------------

  // ------------------- Passcode Details ------------------
  // Selected Data
  const [selectedManagerObject, setSelectedManagerObject] = useState({});
  const [openPasscodeDetailsDialog, setOpenPasscodeDetailsDialog] = useState(false);
  const manager_on_click = (carddata) => {
    //console.log("-->selected card data: ", carddata);
    setOpenPasscodeDetailsDialog(true);
    reset_main_page();
    setSelectedManagerObject(carddata);
  };
  const close_passcode_details_dialog = () => {
    reset_main_page();
    setOpenPasscodeDetailsDialog(false);
  };
  // -------------------------------------------------------

  // --------------- Create Passcode -----------------
  const [openCreatePasscodeDialog, setOpenCreatePasscodeDialog] = useState(false);
  const open_createpasscode_dialog = (selected_passcode) => {
    setOpenCreatePasscodeDialog(true);
  };

  const close_createpasscode_dialog = () => {
    setOpenCreatePasscodeDialog(false);
  };

  const create_passcode_on_click = async () => {
    if (selectedManagerObject.userid === null || selectedManagerObject.userid === undefined || selectedManagerObject.userid === "") {
      setShowAlert2(true);
      setAlertMessage("Userid not found");
    } else {
      const save = await dispatch(generatepasscode_thunk({ userid: selectedManagerObject.userid }));
      //console.log("--save obj1: ", save.payload);
      if (save.payload.status === "fail") {
        setShowAlert2(true);
        setAlertMessage("Passcode generation failed. " + save.payload.msg);
        close_createpasscode_dialog();
      } else if (save.payload.status === "success") {
        dispatch(getallapasscode_thunk());
        close_createpasscode_dialog();
        close_passcode_details_dialog();
        setShowAlert1(true);
        setAlertMessage("Passcode generated successfully. " + save.payload.msg);
      }
    }
  };
  // -------------------------------------------------

  // --------------- Delete Passcode -----------------
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [selectedPasscode, setSelectedPasscode] = useState({});
  const open_confirmation_dialog = (selected_passcode) => {
    setSelectedPasscode(selected_passcode);
    setOpenConfirmationDialog(true);
  };
  const close_confirmation_dialog = () => {
    setSelectedPasscode({});
    setOpenConfirmationDialog(false);
  };
  const delete_passcode_on_click = async () => {
    setOpenConfirmationDialog(false);
    const check_existance = await dispatch(checkpasscodeexistance_thunk(selectedPasscode.passcode.toUpperCase()));
    if (check_existance.payload.count === 0) {
      setShowAlert2(true);
      setAlertMessage("Passcode does not exist");
    } else {
      const check_usability = await dispatch(checkpasscodeusability_thunk(selectedPasscode.passcode.toUpperCase()));
      if (check_usability.payload.count === 0) {
        const delet = await dispatch(deletepasscode_thunk({ id: selectedPasscode._id, userid: selectedPasscode.userid, passcode: selectedPasscode.passcode.toUpperCase() }));
        //console.log("delete response: ", delet);
        dispatch(getallapasscode_thunk());
        close_passcode_details_dialog();
        setShowAlert1(true);
        setAlertMessage("Passcode deleted successfully");
      } else {
        setShowAlert2(true);
        setAlertMessage("Can not delete passcode as it is used in multiple places");
      }
    }
  };
  // -------------------------------------------------

  // ------------------ Misc -------------------
  // Alert
  const [showAlert1, setShowAlert1] = useState(false);
  const [showAlert2, setShowAlert2] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const hide_alert1 = () => {
    setShowAlert1(false);
  };
  const hide_alert2 = () => {
    setShowAlert2(false);
  };

  // Format Date
  const format_date = (date) => {
    const day = new Date(date).getDate();
    const month = new Date(date).getMonth() + 1;
    const year = new Date(date).getFullYear();
    return day + "/" + month + "/" + year;
  };

  // Reset Main Page
  const reset_main_page = () => {
    setSelectedManagerObject({});
  };
  // -------------------------------------------------

  return (
    <>
      <MuiHeader header="Passcode Manager" />
      <div>
        <div style={{ margin: "10px" }}>
          <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <InputLabel id="demo-select-small">Manager Type</InputLabel>
            <Select labelId="demo-select-small" id="demo-select-small" value={managertype} label="Manager Type" onChange={managertype_select_onchange}>
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="manager">Managers</MenuItem>
              <MenuItem value="crc">CRCC</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <div style={{ fontSize: "20px", fontWeight: "bold", color: "#7a7373" }}>
              <div>{userdata ? userdata.length : 0} Record(s) found</div>
              <div>{/* Add user search field */}</div>
            </div>
          </FormControl>
        </div>
      </div>
      <div style={{ height: "60vh", overflowY: "auto", border: "1px solid #d9cfcf" }}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
            {userdata &&
              userdata.map((eachdata, index) => (
                <Grid item xs={2} sm={4} md={4} key={index}>
                  <Card onClick={() => manager_on_click(eachdata)} sx={{ minWidth: 275 }} style={{ cursor: "pointer" }}>
                    <CardContent>
                      <Typography sx={{ fontSize: 16 }} color="text.primary" gutterBottom>
                        {eachdata.username}
                      </Typography>
                      <Typography sx={{ fontSize: 12, mb: 1.5 }} color="text.secondary">
                        {eachdata.userid}
                        <br />
                        {eachdata.managertype}
                      </Typography>
                      <Typography variant="body2" className="passcode_1yr">
                        Passcodes (1 Year): {eachdata.plan_1year.length}
                      </Typography>
                      <Typography variant="body2" className="passcode_4mn">
                        Passcodes (4 Month): {eachdata.plan_4month.length}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </Box>
      </div>

      {/* Passcode Deails Dialog */}
      <div>
        <Dialog fullScreen open={openPasscodeDetailsDialog} onClose={close_passcode_details_dialog} TransitionComponent={Transition}>
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Passcode Details
              </Typography>
              <Button autoFocus color="inherit" onClick={close_passcode_details_dialog}>
                <CloseIcon />
              </Button>
            </Toolbar>
          </AppBar>

          <div>
            {Object.keys(selectedManagerObject).length && (
              <>
                <div style={{ margin: "20px 0" }}>
                  <Grid container spacing={1}>
                    <Grid item xs={1}>
                      <div></div>
                    </Grid>
                    <Grid item xs={10}>
                      <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                          <Typography sx={{ fontSize: 18 }} color="text.primary" gutterBottom>
                            {selectedManagerObject.username}
                            <Button onClick={open_createpasscode_dialog} variant="contained">
                              Create New Passcode
                            </Button>
                          </Typography>
                          <Typography sx={{ fontSize: 14, mb: 1.5 }} color="text.secondary">
                            {selectedManagerObject.userid}
                            <br />
                            {selectedManagerObject.managertype}
                            <br />
                            {selectedManagerObject.status}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={1}>
                      <div></div>
                    </Grid>
                  </Grid>
                </div>
                <div>
                  <Grid container spacing={2}>
                    <Grid item xs={1}>
                      <div></div>
                    </Grid>
                    <Grid item xs={5}>
                      <div>Plan 1 Year</div>
                      <div style={{ height: "270px", border: "1px solid #b5b1b1", overflow: "auto" }}>
                        <div>
                          {selectedManagerObject.plan_1year.map((plan) => (
                            <div key={plan._id} className={plan.passcodestatus === "expired" ? "passcode expired" : "passcode active"}>
                              <div>
                                {plan.passcode}
                                {/* <Button onClick={() => open_confirmation_dialog(plan)} variant="contained" color="error">
                                  Delete
                                </Button> */}

                                <IconButton onClick={() => open_confirmation_dialog(plan)} color="error" aria-label="add to shopping cart">
                                  <DeleteForeverIcon />
                                </IconButton>
                              </div>
                              <div style={{ fontSize: "10px" }}>Created: {format_date(plan.createdon)}</div>
                              <div style={{ fontSize: "10px" }}>Expiry: {format_date(plan.expireon)}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={5}>
                      <div>Plan 4 Month</div>
                      <div style={{ height: "270px", border: "1px solid #b5b1b1", overflow: "auto" }}>
                        <div>
                          {selectedManagerObject.plan_4month.map((plan) => (
                            <div key={plan._id} className={plan.passcodestatus === "expired" ? "passcode expired" : "passcode active"}>
                              <div>
                                {plan.passcode}
                                {/* <Button onClick={() => open_confirmation_dialog(plan)} variant="contained" color="error">
                                  Delete
                                </Button> */}

                                <IconButton onClick={() => open_confirmation_dialog(plan)} color="error" aria-label="add to shopping cart">
                                  <DeleteForeverIcon />
                                </IconButton>
                              </div>
                              <div style={{ fontSize: "10px" }}>Created: {format_date(plan.createdon)}</div>
                              <div style={{ fontSize: "10px" }}>Expiry: {format_date(plan.expireon)}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={1}>
                      <div></div>
                    </Grid>
                  </Grid>
                </div>
              </>
            )}
          </div>

          {/* Ceate Passcode Dialog */}
          <Dialog open={openCreatePasscodeDialog} TransitionComponent={Transition} keepMounted onClose={close_createpasscode_dialog} aria-describedby="alert-dialog-slide-description">
            <DialogTitle>{"Create new passcode"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                By generating new passcode, all the older active passcodes will expire automatically. <br />
                Are you sure you want to generate new passcode?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={close_createpasscode_dialog}>Cancel</Button>
              <Button onClick={create_passcode_on_click}>Agree & Generate</Button>
            </DialogActions>
          </Dialog>

          {/* Confirmation Dialog */}
          <Dialog open={openConfirmationDialog} TransitionComponent={Transition} keepMounted onClose={close_confirmation_dialog} aria-describedby="alert-dialog-slide-description">
            <DialogTitle>{"Confirmation for deleting passcode!"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                This passcode record will be deleted permanently. <br />
                Are you sure you want to delete this record?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={close_confirmation_dialog}>Cancel</Button>
              <Button onClick={delete_passcode_on_click}>Agree & Delete</Button>
            </DialogActions>
          </Dialog>

          {/* Inner Alert */}
          <Dialog open={showAlert2} TransitionComponent={Transition} keepMounted onClose={hide_alert2} aria-describedby="alert-dialog-slide-description">
            <DialogTitle>Info</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{alertMessage}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={hide_alert2}>OK</Button>
            </DialogActions>
          </Dialog>
        </Dialog>
      </div>

      {/* Outer Alert */}
      <Dialog open={showAlert1} TransitionComponent={Transition} keepMounted onClose={hide_alert1} aria-describedby="alert-dialog-slide-description">
        <DialogTitle>Info</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">{alertMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={hide_alert1}>OK</Button>
        </DialogActions>
      </Dialog>

      {/* Loader */}
      <MuiLoader open={loading} />
    </>
  );
}

export default PasscodeManagerPage;
